export default "__VITE_ASSET__BkI35C6P__"